import React from 'react';
import { Switch, Platform } from 'react-native';
import { useTheme } from '../../contexts/ThemeContext';

function WebThemedSwitch({ value, onValueChange, disabled, trackOff, trackOn, thumbColor, isDarkMode }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onValueChange(!value);
      }}
      style={{
        position: 'relative',
        width: 48,
        height: 28,
        borderRadius: 14,
        border: isDarkMode ? '1px solid rgba(255,255,255,0.28)' : '1px solid rgba(0,0,0,0.12)',
        backgroundColor: value ? trackOn : trackOff,
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: 0,
        flexShrink: 0,
        opacity: disabled ? 0.45 : 1,
        outline: 'none',
        boxShadow: value ? `0 0 0 1px ${trackOn}` : 'inset 0 0 0 1px rgba(0,0,0,0.06)',
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: 3,
          left: value ? 23 : 3,
          width: 20,
          height: 20,
          borderRadius: 10,
          backgroundColor: thumbColor,
          boxShadow: '0 1px 4px rgba(0,0,0,0.55)',
          transition: 'left 0.15s ease',
        }}
      />
    </button>
  );
}

/** Switch with visible track/thumb in light and dark mode. */
export function ThemedSwitch({ value, onValueChange, disabled = false }) {
  const { theme, isDarkMode } = useTheme();
  const trackOff = isDarkMode ? '#a3a3b0' : '#b8b8c0';
  const trackOn = theme.brand.accent;
  const thumbColor = '#ffffff';

  if (Platform.OS === 'web') {
    return (
      <WebThemedSwitch
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        trackOff={trackOff}
        trackOn={trackOn}
        thumbColor={thumbColor}
        isDarkMode={isDarkMode}
      />
    );
  }

  return (
    <Switch
      value={value}
      onValueChange={onValueChange}
      disabled={disabled}
      trackColor={{ false: trackOff, true: trackOn }}
      thumbColor={thumbColor}
      ios_backgroundColor={trackOff}
    />
  );
}
